import { BlockSchema } from './Block.types';

import { EmbeddedSnippetBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const EmbeddedSnippetBlockSchema = BlockSchema.extend({
  blockConfig: EmbeddedSnippetBlockConfigSchema,
});

export type EmbeddedSnippetBlock = z.infer<typeof EmbeddedSnippetBlockSchema>;
